import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BrandScrollerProps {
    onBrandClick?: (brand: string) => void;
}

const BrandScroller: React.FC<BrandScrollerProps> = ({ onBrandClick }) => {
    const navigate = useNavigate();

    const brands = [
        { name: 'Michelin', folder: 'michelin' },
        { name: 'Bridgestone', folder: 'bridgestone' },
        { name: 'Goodyear', folder: 'goodyear' },
        { name: 'Continental', folder: 'continental' },
        { name: 'Pirelli', folder: 'pirelli' },
        { name: 'Dunlop', folder: 'dunlop' },
        { name: 'Hankook', folder: 'hankook' },
        { name: 'Yokohama', folder: 'yokohama' },
        { name: 'Bf-Goodrich', folder: 'bf_goodrich' },
        { name: 'Falken', folder: 'falken' },
        { name: 'Kumho', folder: 'kumho' },
        { name: 'Lassa', folder: 'lassa' },
        { name: 'Nokian-Tyres', folder: 'nokian_tyres' },
        { name: 'Petlas', folder: 'petlas' },
        { name: 'Sava', folder: 'sava' },
        { name: 'Starmaxx', folder: 'starmaxx' },
        { name: 'Tatko', folder: 'tatko' },
        { name: 'Wanda', folder: 'wanda' },
        { name: 'Waterfall', folder: 'waterfall' },
        { name: 'Özka', folder: 'özka' },
    ];

    const handleBrandClick = (brandName: string) => {
        if (onBrandClick) {
            onBrandClick(brandName);
        } else {
            // Eğer callback yoksa, direkt lastik sayfasına yönlendir
            navigate(`/lastik?brand=${encodeURIComponent(brandName)}`);
        }
    };

    return (
        <div className="bg-white border-b-2 border-purple-200 py-4 max-w-full overflow-x-hidden">
            <div className="relative">
                {/* Gradient overlays for fade effect */}
                <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-purple-50 to-transparent z-10 pointer-events-none"></div>
                <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-purple-50 to-transparent z-10 pointer-events-none"></div>

                {/* Scrolling brands container */}
                <div className="flex animate-scroll-brands">
                    {/* First set of brands */}
                    {brands.map((brand, index) => (
                        <div
                            key={`brand-1-${index}`}
                            onClick={() => handleBrandClick(brand.name)}
                            className="flex-shrink-0 w-36 h-12 mx-3 flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 bg-white rounded-lg border-2 border-purple-200 hover:border-amber-300 hover:shadow-xl"
                            title={`${brand.name} lastiklerini görüntüle`}
                        >
                            <img
                                src={`/uploads/images/${brand.folder}/brand_logo.webp`}
                                alt={brand.name}
                                className="max-w-full max-h-full object-contain"
                                onError={(e) => {
                                    // Fallback to text if image fails to load
                                    (e.target as HTMLImageElement).style.display = 'none';
                                    const parent = (e.target as HTMLImageElement).parentElement;
                                    if (parent && !parent.querySelector('.brand-text')) {
                                        const text = document.createElement('span');
                                        text.className = 'brand-text font-bold text-purple-700 text-sm text-center';
                                        text.textContent = brand.name;
                                        parent.appendChild(text);
                                    }
                                }}
                            />
                        </div>
                    ))}
                    {/* Duplicate set for seamless loop */}
                    {brands.map((brand, index) => (
                        <div
                            key={`brand-2-${index}`}
                            onClick={() => handleBrandClick(brand.name)}
                            className="flex-shrink-0 w-36 h-12 mx-3 flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 bg-white rounded-lg border-2 border-purple-200 hover:border-gray-500 hover:shadow-xl p-3"
                            title={`${brand.name} lastiklerini görüntüle`}
                        >
                            <img
                                src={`/uploads/images/${brand.folder}/brand_logo.webp`}
                                alt={brand.name}
                                className="max-w-full max-h-full object-contain"
                                onError={(e) => {
                                    (e.target as HTMLImageElement).style.display = 'none';
                                    const parent = (e.target as HTMLImageElement).parentElement;
                                    if (parent && !parent.querySelector('.brand-text')) {
                                        const text = document.createElement('span');
                                        text.className = 'brand-text font-bold text-purple-700 text-sm text-center';
                                        text.textContent = brand.name;
                                        parent.appendChild(text);
                                    }
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BrandScroller;
